export default {
    api: {
        url: process.env.REACT_APP_DEV_BASE_URL,
        mode: 'cors'
    },
    MEDIA_URL: process.env.DEV_MEDIA,
}